'use client';

import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { ToneIcon } from '../tone-icon/tone-icon';
import { AlertRootContext } from './context/alert-root.context';
import { alertIconRecipe } from './styles/alert-icon.styles';
import type { AlertIconPropsInterface } from './types/alert-icon.types';

/**
 * @since 10.0.0
 */
export const AlertIcon = forwardRef<SVGSVGElement, AlertIconPropsInterface>(
  (props, forwardedRef) => {
    const { css: cssProp, ...rest } = props;
    const { tone } = useContext(AlertRootContext);

    return (
      <Icon
        data-c11n-component="Alert.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size="md"
        css={{
          ...alertIconRecipe.raw({ tone }),
          ...cssProp,
        }}
        {...rest}
      >
        <ToneIcon tone={tone} />
      </Icon>
    );
  },
);

AlertIcon.displayName = 'Alert.Icon';
